export default "__VITE_ASSET__BE7v0yn7__"